import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ItemForm from 'components/Item/Form/ItemForm'
import BulkForm from 'components/Item/Form/BulkForm'

import { getIsItemsLoading } from 'store/Items/selector'
import { getIsPriceLevelsLoading } from 'store/PriceLevels/selectors'
import { getIsRevenueCentersLoading } from 'store/RevenueCenters/selector'
import { getIsCategoriesLoading } from 'store/Categories/selectors'
import { getIsSalesEventTypeLoading } from 'store/SalesEventTypes/selectors'
import { getIsMenusLoading } from 'store/Menus/selectors'
import { getIsItemMappingsLoading } from 'store/ItemMappings/selectors'

const ItemDetails = () => {
  const { state: urlQueryParamsState } = useLocation()

  const isLoadingItems = useSelector(getIsItemsLoading)
  const isLoadingPriceLevels = useSelector(getIsPriceLevelsLoading)
  const isLoadingRevenueCenters = useSelector(
    getIsRevenueCentersLoading
  )
  const isLoadingCategories = useSelector(getIsCategoriesLoading)
  const isLoadingSalesEvents = useSelector(getIsSalesEventTypeLoading)
  const isMenusLoading = useSelector(getIsMenusLoading)
  const isItemMappingsLoading = useSelector(getIsItemMappingsLoading)

  const isBulkEdit = urlQueryParamsState?.itemUuid === 'bulk'
  const isLoading =
    isLoadingItems ||
    isLoadingPriceLevels ||
    isLoadingRevenueCenters ||
    isLoadingCategories ||
    isLoadingSalesEvents ||
    isMenusLoading ||
    isItemMappingsLoading

  return isBulkEdit ? (
    <BulkForm isLoading={isLoading} />
  ) : (
    <ItemForm isLoading={isLoading} />
  )
}

export default ItemDetails
